import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=00dc9680&"
import script from "./Renderer.vue?vue&type=script&lang=ts&"
export * from "./Renderer.vue?vue&type=script&lang=ts&"
import style0 from "./Renderer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
